<template>
  <div v-if="currentCandidature && currentOffre">
    <div class="mt-4 mb-4">
      <div class="row">
        <div
          class="col-md-6 col-lg-8 offset-lg-4 offset-md-6 text-md-right"
          v-if="
            currentOffre.statut === 0 && currentCandidature.embauche === false
          "
        >
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: 'rh_candidature_show_activite-create',
                  id: currentCandidature.id,
                  offreId: currentOffre.id,
                  prov: prov,
                })
                .catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvelle activité
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            :currentCandidature="currentCandidature"
            :currentOffre="currentOffre"
            :prov="prov"
            :headers="selectedHeaders"
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL_A from '@/http/rh/candidature/activite';
import URL_O from '@/http/rh/offre-emploi';
import DataTable from './DataTable.vue';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isSelect: false,
      selectedHeaders: [],
      headers: [
        {
          text: 'Date début',
          align: 'start',
          sortable: true,
          value: 'date_debut',
        },
        {
          text: 'Date fin',
          align: 'start',
          sortable: true,
          value: 'date_fin',
        },
        {
          text: 'Titre',
          align: 'start',
          sortable: true,
          value: 'titre',
        },
        {
          text: 'Appréciation',
          align: 'start',
          sortable: true,
          value: 'appreciation',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
      currentOffre: null,
      prov: null,
      id: null,
    };
  },
  computed: {
    ...mapGetters('candidature', ['currentCandidature']),
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  components: {
    DataTable,
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.prov = this.$route.params.prov;

      window.axios
        .get(URL_O.OFFRE_EMPLOI + '/' + this.$route.params.offreId)
        .then((resp) => {
          this.currentOffre = resp.data.offre_emploi;
        })
        .catch();
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL_A.ACTIVITE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
